<div
  class="offcanvas offcanvas-end navbar-brand-box p-0 z-1"
  style="top: 70px; width: 400px !important; visibility: visible !important; height: calc(100vh - 70px);"
  data-bs-scroll="true"
  data-bs-backdrop="false"
  tabindex="-1"
  id="offcanvasScrollingTabsConf"
  aria-labelledby="offcanvasScrollingLabel"
>
  <div class="offcanvas-header ps-0 mb-0 offcanvas-divider">
    <div id="sidebar-menu" class="offcanvas-header p-0">
      <ul class="metismenu list-unstyled">
        <li draggable="false">
          <a class="side-nav-link-ref">
            <h5 class="mb-0">
              {{ title }}
            </h5>
          </a>
        </li>
      </ul>
    </div>
    <div
      class="text-reset enablePointer"
      data-bs-dismiss="offcanvas"
      aria-label="Close"
      (click)="hideOffcanvas()"
    >
      <i class="mdi mdi-close font-size-22 icon-close"></i>
    </div>
  </div>
  <div class="offcanvas-menu p-0 m-0 offcanvas-scrollbar flex-grow-1" [ngClass]="{'overflow-x-hidden': offcanvas_data.length == 1}">
    <!-- <ngx-simplebar data-simplebar="init"> -->
      <ng-container *ngIf="offcanvas_data.length == 1">
        <ng-container *ngFor="let tab of offcanvas_data">
          <div id="sidebar-menu" class="offcanvas-menu">
            <!-- Left Menu Start -->
            <ul class="metismenu list-unstyled">
              <!-- {{menuItems}} -->
              <ng-container *ngFor="let cat of tab?.data; let i = index">
                <li
                  *ngIf="cat.show"
                  draggable="false"
                  class="offcanvas-header-bg"
                >
                  <a class="side-nav-link-ref">
                    <span>{{ cat.cat }}</span>
                  </a>
                </li>
                <div *ngFor="let item of cat?.list; let j = index">

                  <div
                    *ngIf="item?.postFooter"
                    [ngClass]="
                      i == 0 && j == 0
                        ? i == tab.data.length - 1 && j == cat.list.length - 1
                          ? ''
                          : 'border-bottom-3d'
                        : i == tab.data.length - 1 && j == cat.list.length - 1
                        ? 'border-top-3d'
                        : 'border-3d'
                    "
                  >
                    <app-tab-post-footer-component
                      [tab_id]="tab_id"
                    ></app-tab-post-footer-component>
                  </div>
                  <div
                    *ngIf="item?.enableAds"
                    [ngClass]="
                      i == 0 && j == 0
                        ? i == tab.data.length - 1 && j == cat.list.length - 1
                          ? ''
                          : 'border-bottom-3d'
                        : i == tab.data.length - 1 && j == cat.list.length - 1
                        ? 'border-top-3d'
                        : 'border-3d'
                    "
                  >
                    <app-tab-enable-ads-component
                      [tab_id]="tab_id"
                    ></app-tab-enable-ads-component>
                  </div>
                  <div
                    *ngIf="item?.enableSetGroup"
                    [ngClass]="
                      i == 0 && j == 0
                        ? i == tab.data.length - 1 && j == cat.list.length - 1
                          ? ''
                          : 'border-bottom-3d'
                        : i == tab.data.length - 1 && j == cat.list.length - 1
                        ? 'border-top-3d'
                        : 'border-3d'
                    "
                  >
                    <app-tab-set-group-component
                      [tab_id]="tab_id"
                      [config]="item?.config"
                    ></app-tab-set-group-component>
                  </div>
                  <div
                    *ngIf="item?.enableSetBot"
                    [ngClass]="
                      i == 0 && j == 0
                        ? i == tab.data.length - 1 && j == cat.list.length - 1
                          ? ''
                          : 'border-bottom-3d'
                        : i == tab.data.length - 1 && j == cat.list.length - 1
                        ? 'border-top-3d'
                        : 'border-3d'
                    "
                  >
                    <app-tab-set-bot-component
                      [tab_id]="tab_id"
                      [config]="item?.config"
                    ></app-tab-set-bot-component>
                  </div>
                  <div
                    *ngIf="item?.enableSetAppbar"
                    [ngClass]="
                      i == 0 && j == 0
                        ? i == tab.data.length - 1 && j == cat.list.length - 1
                          ? ''
                          : 'border-bottom-3d'
                        : i == tab.data.length - 1 && j == cat.list.length - 1
                        ? 'border-top-3d'
                        : 'border-3d'
                    "
                  >
                    <app-tab-set-appbar-component
                      [tab_id]="tab_id"
                      [config]="item?.config"
                    ></app-tab-set-appbar-component>
                  </div>
                  <div
                    *ngIf="item?.enableMenuCode"
                    [ngClass]="
                      i == 0 && j == 0
                        ? i == tab.data.length - 1 && j == cat.list.length - 1
                          ? ''
                          : 'border-bottom-3d'
                        : i == tab.data.length - 1 && j == cat.list.length - 1
                        ? 'border-top-3d'
                        : 'border-3d'
                    "
                  >
                    <app-tab-menu-code-component
                      [tab_id]="tab_id"
                      [config]="item?.config"
                    ></app-tab-menu-code-component>
                  </div>
                  <div
                    *ngIf="item?.enableVideoCall"
                    [ngClass]="
                      i == 0 && j == 0
                        ? i == tab.data.length - 1 && j == cat.list.length - 1
                          ? ''
                          : 'border-bottom-3d'
                        : i == tab.data.length - 1 && j == cat.list.length - 1
                        ? 'border-top-3d'
                        : 'border-3d'
                    "
                  >
                    <app-tab-enable-video-call-component
                      [tab_id]="tab_id"
                    ></app-tab-enable-video-call-component>
                  </div>
                  <div
                    *ngIf="item?.video"
                    [ngClass]="
                      i == 0 && j == 0
                        ? i == tab.data.length - 1 && j == cat.list.length - 1
                          ? ''
                          : 'border-bottom-3d'
                        : i == tab.data.length - 1 && j == cat.list.length - 1
                        ? 'border-top-3d'
                        : 'border-3d'
                    "
                  >
                    <app-tab-video-component
                      [tab_id]="tab_id"
                    ></app-tab-video-component>
                  </div>
                  <div
                    *ngIf="item?.invitationLink"
                    [ngClass]="
                      i == 0 && j == 0
                        ? i == tab.data.length - 1 && j == cat.list.length - 1
                          ? ''
                          : 'border-bottom-3d'
                        : i == tab.data.length - 1 && j == cat.list.length - 1
                        ? 'border-top-3d'
                        : 'border-3d'
                    "
                  >
                    <app-tab-invitation-link-component
                      [tab_id]="tab_id"
                    ></app-tab-invitation-link-component>
                  </div>
                  <div
                    *ngIf="item?.qr"
                    [ngClass]="
                      i == 0 && j == 0
                        ? i == tab.data.length - 1 && j == cat.list.length - 1
                          ? ''
                          : 'border-bottom-3d'
                        : i == tab.data.length - 1 && j == cat.list.length - 1
                        ? 'border-top-3d'
                        : 'border-3d'
                    "
                  >
                    <app-tab-qr-component
                      [tab_id]="tab_id"
                    ></app-tab-qr-component>
                  </div>
                  <div
                    *ngIf="item?.webView"
                    [ngClass]="
                      i == 0 && j == 0
                        ? i == tab.data.length - 1 && j == cat.list.length - 1
                          ? ''
                          : 'border-bottom-3d'
                        : i == tab.data.length - 1 && j == cat.list.length - 1
                        ? 'border-top-3d'
                        : 'border-3d'
                    "
                  >
                    <app-tab-web-view-component
                      [tab_id]="tab_id"
                    ></app-tab-web-view-component>
                  </div>
                  <div
                    *ngIf="item?.search"
                    [ngClass]="
                      i == 0 && j == 0
                        ? i == tab.data.length - 1 && j == cat.list.length - 1
                          ? ''
                          : 'border-bottom-3d'
                        : i == tab.data.length - 1 && j == cat.list.length - 1
                        ? 'border-top-3d'
                        : 'border-3d'
                    "
                  >
                    <app-tab-search-component
                      [tab_id]="tab_id"
                    ></app-tab-search-component>
                  </div>
                  <div
                    *ngIf="item?.mapSearch"
                    [ngClass]="
                      i == 0 && j == 0
                        ? i == tab.data.length - 1 && j == cat.list.length - 1
                          ? ''
                          : 'border-bottom-3d'
                        : i == tab.data.length - 1 && j == cat.list.length - 1
                        ? 'border-top-3d'
                        : 'border-3d'
                    "
                  >
                    <app-tab-map-search-component
                      [tab_id]="tab_id"
                    ></app-tab-map-search-component>
                  </div>
                  <div
                    *ngIf="item?.tabInfo"
                    [ngClass]="
                      i == 0 && j == 0
                        ? i == tab.data.length - 1 && j == cat.list.length - 1
                          ? ''
                          : 'border-bottom-3d'
                        : i == tab.data.length - 1 && j == cat.list.length - 1
                        ? 'border-top-3d'
                        : 'border-3d'
                    "
                  >
                    <app-tab-info-component
                      [tab_id]="tab_id"
                      [config]="item?.config"
                    ></app-tab-info-component>
                  </div>
                  <div
                      *ngIf="item.onClickSelector"
                      [ngClass]="
                        i == 0 && j == 0
                          ? i == tab.data.length - 1 && j == cat.list.length - 1
                            ? ''
                            : 'border-bottom-3d'
                          : i == tab.data.length - 1 && j == cat.list.length - 1
                          ? 'border-top-3d'
                          : 'border-3d'
                      "
                    >
                      <tab-selector-component
                      [tab_id]="tab_id"
                      [config]="item?.config"
                      ></tab-selector-component>
                    </div>
                  <div
                      *ngIf="item.search_query"
                      [ngClass]="
                        i == 0 && j == 0
                          ? i == tab.data.length - 1 && j == cat.list.length - 1
                            ? ''
                            : 'border-bottom-3d'
                          : i == tab.data.length - 1 && j == cat.list.length - 1
                          ? 'border-top-3d'
                          : 'border-3d'
                      "
                    >
                      <app-tab-query-component
                      [tab_id]="tab_id"
                      [config]="item?.config"
                      ></app-tab-query-component>
                    </div>
                  <div
                    *ngIf="item?.tabImage"
                    [ngClass]="
                      i == 0 && j == 0
                        ? i == tab.data.length - 1 && j == cat.list.length - 1
                          ? ''
                          : 'border-bottom-3d'
                        : i == tab.data.length - 1 && j == cat.list.length - 1
                        ? 'border-top-3d'
                        : 'border-3d'
                    "
                  >
                    <app-tab-image-component
                      [tab_id]="tab_id"
                      [config]="item?.config"
                    ></app-tab-image-component>
                  </div>
                  <div
                    *ngIf="item?.tabBgColor"
                    [ngClass]="
                      i == 0 && j == 0
                        ? i == tab.data.length - 1 && j == cat.list.length - 1
                          ? ''
                          : 'border-bottom-3d'
                        : i == tab.data.length - 1 && j == cat.list.length - 1
                        ? 'border-top-3d'
                        : 'border-3d'
                    "
                  >
                    <app-tab-bg-color-component
                      [tab_id]="tab_id"
                      [config]="item?.config"
                    ></app-tab-bg-color-component>
                  </div>
                  <div
                    *ngIf="item?.chatLabel"
                    [ngClass]="
                      i == 0 && j == 0
                        ? i == tab.data.length - 1 && j == cat.list.length - 1
                          ? ''
                          : 'border-bottom-3d'
                        : i == tab.data.length - 1 && j == cat.list.length - 1
                        ? 'border-top-3d'
                        : 'border-3d'
                    "
                  >
                    <app-tab-chatLabel-component
                      [tab_id]="tab_id"
                    ></app-tab-chatLabel-component>
                  </div>
                  <div
                    *ngIf="item?.tabReview"
                    [ngClass]="
                      i == 0 && j == 0
                        ? i == tab.data.length - 1 && j == cat.list.length - 1
                          ? ''
                          : 'border-bottom-3d'
                        : i == tab.data.length - 1 && j == cat.list.length - 1
                        ? 'border-top-3d'
                        : 'border-3d'
                    "
                  >
                    <app-tab-review-component
                      [tab_id]="tab_id"
                    ></app-tab-review-component>
                  </div>
                  <div
                    *ngIf="item?.tabStoreInfo"
                    [ngClass]="
                      i == 0 && j == 0
                        ? i == tab.data.length - 1 && j == cat.list.length - 1
                          ? ''
                          : 'border-bottom-3d'
                        : i == tab.data.length - 1 && j == cat.list.length - 1
                        ? 'border-top-3d'
                        : 'border-3d'
                    "
                  >
                    <app-tab-store-info-component
                      [tab_id]="tab_id"
                    ></app-tab-store-info-component>
                  </div>
                  <div
                    *ngIf="item?.tabPollInfo"
                    [ngClass]="
                      i == 0 && j == 0
                        ? i == tab.data.length - 1 && j == cat.list.length - 1
                          ? ''
                          : 'border-bottom-3d'
                        : i == tab.data.length - 1 && j == cat.list.length - 1
                        ? 'border-top-3d'
                        : 'border-3d'
                    "
                  >
                    <app-tab-poll-info-component
                      [tab_id]="tab_id"
                    ></app-tab-poll-info-component>
                  </div>
                  <div
                    *ngIf="item?.chatWithAdmin"
                    [ngClass]="
                      i == 0 && j == 0
                        ? i == tab.data.length - 1 && j == cat.list.length - 1
                          ? ''
                          : 'border-bottom-3d'
                        : i == tab.data.length - 1 && j == cat.list.length - 1
                        ? 'border-top-3d'
                        : 'border-3d'
                    "
                  >
                    <app-tab-enable-chat-with-admin-component
                      [tab_id]="tab_id"
                    ></app-tab-enable-chat-with-admin-component>
                  </div>
                  <div
                    *ngIf="item?.add_tags"
                    [ngClass]="
                      i == 0 && j == 0
                        ? i == tab.data.length - 1 && j == cat.list.length - 1
                          ? ''
                          : 'border-bottom-3d'
                        : i == tab.data.length - 1 && j == cat.list.length - 1
                        ? 'border-top-3d'
                        : 'border-3d'
                    "
                  >
                    <app-tab-tag-component
                      [tab_id]="tab_id"
                    ></app-tab-tag-component>
                  </div>
                  <div
                    *ngIf="item?.chatWithAdminIcon"
                    [ngClass]="
                      i == 0 && j == 0
                        ? i == tab.data.length - 1 && j == cat.list.length - 1
                          ? ''
                          : 'border-bottom-3d'
                        : i == tab.data.length - 1 && j == cat.list.length - 1
                        ? 'border-top-3d'
                        : 'border-3d'
                    "
                  >
                    <app-tab-chat-with-admin-icon-component
                      [tab_id]="tab_id"
                    ></app-tab-chat-with-admin-icon-component>
                  </div>
                  <div
                    *ngIf="item?.postTags"
                    [ngClass]="
                      i == 0 && j == 0
                        ? i == tab.data.length - 1 && j == cat.list.length - 1
                          ? ''
                          : 'border-bottom-3d'
                        : i == tab.data.length - 1 && j == cat.list.length - 1
                        ? 'border-top-3d'
                        : 'border-3d'
                    "
                  >
                    <app-tab-post-tags-component
                      [tab_id]="tab_id"
                    ></app-tab-post-tags-component>
                  </div>
                  <div
                    *ngIf="item?.contextMenu"
                    [ngClass]="
                      i == 0 && j == 0
                        ? i == tab.data.length - 1 && j == cat.list.length - 1
                          ? ''
                          : 'border-bottom-3d'
                        : i == tab.data.length - 1 && j == cat.list.length - 1
                        ? 'border-top-3d'
                        : 'border-3d'
                    "
                  >
                    <app-tab-post-context-menu-component
                      [tab_id]="tab_id"
                    ></app-tab-post-context-menu-component>
                  </div>
                  <div
                    *ngIf="item?.bubble_theme"
                    [ngClass]="
                      i == 0 && j == 0
                        ? i == tab.data.length - 1 && j == cat.list.length - 1
                          ? ''
                          : 'border-bottom-3d'
                        : i == tab.data.length - 1 && j == cat.list.length - 1
                        ? 'border-top-3d'
                        : 'border-3d'
                    "
                  >
                    <app-tab-bubble-themes-component
                      [tab_id]="tab_id"
                    ></app-tab-bubble-themes-component>
                  </div>
                  <div
                    *ngIf="item?.enable_invitation_links"
                    [ngClass]="
                      i == 0 && j == 0
                        ? i == tab.data.length - 1 && j == cat.list.length - 1
                          ? ''
                          : 'border-bottom-3d'
                        : i == tab.data.length - 1 && j == cat.list.length - 1
                        ? 'border-top-3d'
                        : 'border-3d'
                    "
                  >
                    <app-tab-enable-invitation-link-component
                      [tab_id]="tab_id"
                    ></app-tab-enable-invitation-link-component>
                  </div>
                  <div
                    *ngIf="item?.enable_public_group"
                    [ngClass]="
                      i == 0 && j == 0
                        ? i == tab.data.length - 1 && j == cat.list.length - 1
                          ? ''
                          : 'border-bottom-3d'
                        : i == tab.data.length - 1 && j == cat.list.length - 1
                        ? 'border-top-3d'
                        : 'border-3d'
                    "
                  >
                    <app-tab-enable-public-group-component
                      [tab_id]="tab_id"
                    ></app-tab-enable-public-group-component>
                  </div>
                  <div
                    *ngIf="item?.channel_admin_talk"
                    [ngClass]="
                      i == 0 && j == 0
                        ? i == tab.data.length - 1 && j == cat.list.length - 1
                          ? ''
                          : 'border-bottom-3d'
                        : i == tab.data.length - 1 && j == cat.list.length - 1
                        ? 'border-top-3d'
                        : 'border-3d'
                    "
                  >
                    <app-tab-channel-chat-with-admin-component
                      [tab_id]="tab_id"
                    ></app-tab-channel-chat-with-admin-component>
                  </div>
                  <div
                    *ngIf="item?.channel_footer"
                    [ngClass]="
                      i == 0 && j == 0
                        ? i == tab.data.length - 1 && j == cat.list.length - 1
                          ? ''
                          : 'border-bottom-3d'
                        : i == tab.data.length - 1 && j == cat.list.length - 1
                        ? 'border-top-3d'
                        : 'border-3d'
                    "
                  >
                    <app-tab-channel-footer-component
                      [tab_id]="tab_id"
                    ></app-tab-channel-footer-component>
                  </div>
                  <div
                    *ngIf="item?.channel_context_menu"
                    [ngClass]="
                      i == 0 && j == 0
                        ? i == tab.data.length - 1 && j == cat.list.length - 1
                          ? ''
                          : 'border-bottom-3d'
                        : i == tab.data.length - 1 && j == cat.list.length - 1
                        ? 'border-top-3d'
                        : 'border-3d'
                    "
                  >
                    <app-tab-channel-context-menu-component
                      [tab_id]="tab_id"
                    ></app-tab-channel-context-menu-component>
                  </div>
                </div>
              </ng-container>
            </ul>
          </div>
        </ng-container>
      </ng-container>
      <tabset
        [justified]="true"
        class="nav-tabs nav-tabs-custom nav-justified tabPrimaryFilled h-100 offcanvas-tabset"
        *ngIf="offcanvas_data.length > 1"
      >
        <ng-container *ngFor="let tab of offcanvas_data">
          <tab [heading]="tab?.tab" class="font-size-14 fw-bold">
            <div id="sidebar-menu" class="offcanvas-menu p-0 overflow-x-hidden" style="height: calc(100vh - 188px)">
              <!-- Left Menu Start -->
              <ul class="metismenu list-unstyled p-0">
                <!-- {{menuItems}} -->

                <ng-container *ngFor="let cat of tab?.data">
                  <li
                    *ngIf="cat.show"
                    draggable="false"
                    class="offcanvas-header-bg"
                  >
                    <a class="side-nav-link-ref">
                      <span>{{ cat.cat }}</span>
                    </a>
                  </li>

                  <div *ngFor="let item of cat?.list; let j = index">

                    <div
                      *ngIf="item?.postFooter"
                      [ngClass]="
                        i == 0 && j == 0
                          ? i == tab.data.length - 1 && j == cat.list.length - 1
                            ? ''
                            : 'border-bottom-3d'
                          : i == tab.data.length - 1 && j == cat.list.length - 1
                          ? 'border-top-3d'
                          : 'border-3d'
                      "
                    >
                      <app-tab-post-footer-component
                        [tab_id]="tab_id"
                      ></app-tab-post-footer-component>
                    </div>
                    <div
                      *ngIf="item?.enableAds"
                      [ngClass]="
                        i == 0 && j == 0
                          ? i == tab.data.length - 1 && j == cat.list.length - 1
                            ? ''
                            : 'border-bottom-3d'
                          : i == tab.data.length - 1 && j == cat.list.length - 1
                          ? 'border-top-3d'
                          : 'border-3d'
                      "
                    >
                      <app-tab-enable-ads-component
                        [tab_id]="tab_id"
                      ></app-tab-enable-ads-component>
                    </div>
                    <div
                      *ngIf="item?.enableSetGroup"
                      [ngClass]="
                        i == 0 && j == 0
                          ? i == tab.data.length - 1 && j == cat.list.length - 1
                            ? ''
                            : 'border-bottom-3d'
                          : i == tab.data.length - 1 && j == cat.list.length - 1
                          ? 'border-top-3d'
                          : 'border-3d'
                      "
                    >
                      <app-tab-set-group-component
                        [tab_id]="tab_id"
                        [config]="item?.config"
                      ></app-tab-set-group-component>
                    </div>
                    <div
                      *ngIf="item?.enableSetBot"
                      [ngClass]="
                        i == 0 && j == 0
                          ? i == tab.data.length - 1 && j == cat.list.length - 1
                            ? ''
                            : 'border-bottom-3d'
                          : i == tab.data.length - 1 && j == cat.list.length - 1
                          ? 'border-top-3d'
                          : 'border-3d'
                      "
                    >
                      <app-tab-set-bot-component
                        [tab_id]="tab_id"
                        [config]="item?.config"
                      ></app-tab-set-bot-component>
                    </div>
                    <div
                    *ngIf="item?.enableSetAppbar"
                    [ngClass]="
                      i == 0 && j == 0
                        ? i == tab.data.length - 1 && j == cat.list.length - 1
                          ? ''
                          : 'border-bottom-3d'
                        : i == tab.data.length - 1 && j == cat.list.length - 1
                        ? 'border-top-3d'
                        : 'border-3d'
                    "
                  >
                    <app-tab-set-appbar-component
                      [tab_id]="tab_id"
                      [config]="item?.config"
                    ></app-tab-set-appbar-component>
                  </div>
                    <div
                      *ngIf="item?.enableMenuCode"
                      [ngClass]="
                        i == 0 && j == 0
                          ? i == tab.data.length - 1 && j == cat.list.length - 1
                            ? ''
                            : 'border-bottom-3d'
                          : i == tab.data.length - 1 && j == cat.list.length - 1
                          ? 'border-top-3d'
                          : 'border-3d'
                      "
                    >
                      <app-tab-menu-code-component
                        [tab_id]="tab_id"
                        [config]="item?.config"
                      ></app-tab-menu-code-component>
                    </div>
                    <div
                      *ngIf="item?.enableVideoCall"
                      [ngClass]="
                        i == 0 && j == 0
                          ? i == tab.data.length - 1 && j == cat.list.length - 1
                            ? ''
                            : 'border-bottom-3d'
                          : i == tab.data.length - 1 && j == cat.list.length - 1
                          ? 'border-top-3d'
                          : 'border-3d'
                      "
                    >
                      <app-tab-enable-video-call-component
                        [tab_id]="tab_id"
                      ></app-tab-enable-video-call-component>
                    </div>

                    <div
                      *ngIf="item?.video"
                      [ngClass]="
                        i == 0 && j == 0
                          ? i == tab.data.length - 1 && j == cat.list.length - 1
                            ? ''
                            : 'border-bottom-3d'
                          : i == tab.data.length - 1 && j == cat.list.length - 1
                          ? 'border-top-3d'
                          : 'border-3d'
                      "
                    >
                      <app-tab-video-component
                        [tab_id]="tab_id"
                      ></app-tab-video-component>
                    </div>
                    <div
                      *ngIf="item?.invitationLink"
                      [ngClass]="
                        i == 0 && j == 0
                          ? i == tab.data.length - 1 && j == cat.list.length - 1
                            ? ''
                            : 'border-bottom-3d'
                          : i == tab.data.length - 1 && j == cat.list.length - 1
                          ? 'border-top-3d'
                          : 'border-3d'
                      "
                    >
                      <app-tab-invitation-link-component
                        [tab_id]="tab_id"
                      ></app-tab-invitation-link-component>
                    </div>
                    <div
                      *ngIf="item?.qr"
                      [ngClass]="
                        i == 0 && j == 0
                          ? i == tab.data.length - 1 && j == cat.list.length - 1
                            ? ''
                            : 'border-bottom-3d'
                          : i == tab.data.length - 1 && j == cat.list.length - 1
                          ? 'border-top-3d'
                          : 'border-3d'
                      "
                    >
                      <app-tab-qr-component
                        [tab_id]="tab_id"
                      ></app-tab-qr-component>
                    </div>
                    <div
                      *ngIf="item?.webView"
                      [ngClass]="
                        i == 0 && j == 0
                          ? i == tab.data.length - 1 && j == cat.list.length - 1
                            ? ''
                            : 'border-bottom-3d'
                          : i == tab.data.length - 1 && j == cat.list.length - 1
                          ? 'border-top-3d'
                          : 'border-3d'
                      "
                    >
                      <app-tab-web-view-component
                        [tab_id]="tab_id"
                      ></app-tab-web-view-component>
                    </div>
                    <div
                      *ngIf="item?.search"
                      [ngClass]="
                        i == 0 && j == 0
                          ? i == tab.data.length - 1 && j == cat.list.length - 1
                            ? ''
                            : 'border-bottom-3d'
                          : i == tab.data.length - 1 && j == cat.list.length - 1
                          ? 'border-top-3d'
                          : 'border-3d'
                      "
                    >
                      <app-tab-search-component
                        [tab_id]="tab_id"
                      ></app-tab-search-component>
                    </div>
                    <div
                      *ngIf="item?.mapSearch"
                      [ngClass]="
                        i == 0 && j == 0
                          ? i == tab.data.length - 1 && j == cat.list.length - 1
                            ? ''
                            : 'border-bottom-3d'
                          : i == tab.data.length - 1 && j == cat.list.length - 1
                          ? 'border-top-3d'
                          : 'border-3d'
                      "
                    >
                      <app-tab-map-search-component
                        [tab_id]="tab_id"
                      ></app-tab-map-search-component>
                    </div>
                    <div
                      *ngIf="item?.tabInfo"
                      [ngClass]="
                        i == 0 && j == 0
                          ? i == tab.data.length - 1 && j == cat.list.length - 1
                            ? ''
                            : 'border-bottom-3d'
                          : i == tab.data.length - 1 && j == cat.list.length - 1
                          ? 'border-top-3d'
                          : 'border-3d'
                      "
                    >
                      <app-tab-info-component
                        [tab_id]="tab_id"
                        [config]="item?.config"
                      ></app-tab-info-component>
                    </div>
                    <div
                      *ngIf="item.onClickSelector"
                      [ngClass]="
                        i == 0 && j == 0
                          ? i == tab.data.length - 1 && j == cat.list.length - 1
                            ? ''
                            : 'border-bottom-3d'
                          : i == tab.data.length - 1 && j == cat.list.length - 1
                          ? 'border-top-3d'
                          : 'border-3d'
                      "
                    >
                    <tab-selector-component
                    [tab_id]="tab_id"
                    [config]="item?.config"
                  ></tab-selector-component>
                    </div>
                    <div
                      *ngIf="item.search_query"
                      [ngClass]="
                        i == 0 && j == 0
                          ? i == tab.data.length - 1 && j == cat.list.length - 1
                            ? ''
                            : 'border-bottom-3d'
                          : i == tab.data.length - 1 && j == cat.list.length - 1
                          ? 'border-top-3d'
                          : 'border-3d'
                      "
                    >
                      <app-tab-query-component
                      [tab_id]="tab_id"
                      [config]="item?.config"
                      ></app-tab-query-component>
                    </div>
                    <div
                    *ngIf="item?.tabImage"
                    [ngClass]="
                      i == 0 && j == 0
                        ? i == tab.data.length - 1 && j == cat.list.length - 1
                          ? ''
                          : 'border-bottom-3d'
                        : i == tab.data.length - 1 && j == cat.list.length - 1
                        ? 'border-top-3d'
                        : 'border-3d'
                    "
                  >
                    <app-tab-image-component
                      [tab_id]="tab_id"
                      [config]="item?.config"
                    ></app-tab-image-component>
                  </div>
                  <div
                    *ngIf="item?.tabBgColor"
                    [ngClass]="
                      i == 0 && j == 0
                        ? i == tab.data.length - 1 && j == cat.list.length - 1
                          ? ''
                          : 'border-bottom-3d'
                        : i == tab.data.length - 1 && j == cat.list.length - 1
                        ? 'border-top-3d'
                        : 'border-3d'
                    "
                  >
                    <app-tab-bg-color-component
                      [tab_id]="tab_id"
                      [config]="item?.config"
                    ></app-tab-bg-color-component>
                  </div>
                    <div
                      *ngIf="item?.chatLabel"
                      [ngClass]="
                        i == 0 && j == 0
                          ? i == tab.data.length - 1 && j == cat.list.length - 1
                            ? ''
                            : 'border-bottom-3d'
                          : i == tab.data.length - 1 && j == cat.list.length - 1
                          ? 'border-top-3d'
                          : 'border-3d'
                      "
                    >
                      <app-tab-chatLabel-component
                        [tab_id]="tab_id"
                      ></app-tab-chatLabel-component>
                    </div>
                    <div
                    *ngIf="item?.tabReview"
                    [ngClass]="
                      i == 0 && j == 0
                        ? i == tab.data.length - 1 && j == cat.list.length - 1
                          ? ''
                          : 'border-bottom-3d'
                        : i == tab.data.length - 1 && j == cat.list.length - 1
                        ? 'border-top-3d'
                        : 'border-3d'
                    "
                  >
                    <app-tab-review-component
                      [tab_id]="tab_id"
                    ></app-tab-review-component>
                  </div>
                    <div
                      *ngIf="item?.tabStoreInfo"
                      [ngClass]="
                        i == 0 && j == 0
                          ? i == tab.data.length - 1 && j == cat.list.length - 1
                            ? ''
                            : 'border-bottom-3d'
                          : i == tab.data.length - 1 && j == cat.list.length - 1
                          ? 'border-top-3d'
                          : 'border-3d'
                      "
                    >
                      <app-tab-store-info-component
                        [tab_id]="tab_id"
                      ></app-tab-store-info-component>
                    </div>
                    <div
                      *ngIf="item?.tabPollInfo"
                      [ngClass]="
                        i == 0 && j == 0
                          ? i == tab.data.length - 1 && j == cat.list.length - 1
                            ? ''
                            : 'border-bottom-3d'
                          : i == tab.data.length - 1 && j == cat.list.length - 1
                          ? 'border-top-3d'
                          : 'border-3d'
                      "
                    >
                      <app-tab-poll-info-component
                        [tab_id]="tab_id"
                      ></app-tab-poll-info-component>
                    </div>
                    <div
                      *ngIf="item?.chatWithAdmin"
                      [ngClass]="
                        i == 0 && j == 0
                          ? i == tab.data.length - 1 && j == cat.list.length - 1
                            ? ''
                            : 'border-bottom-3d'
                          : i == tab.data.length - 1 && j == cat.list.length - 1
                          ? 'border-top-3d'
                          : 'border-3d'
                      "
                    >
                      <app-tab-enable-chat-with-admin-component
                        [tab_id]="tab_id"
                      ></app-tab-enable-chat-with-admin-component>
                    </div>
                    <div
                      *ngIf="item?.add_tags"
                      [ngClass]="
                        i == 0 && j == 0
                          ? i == tab.data.length - 1 && j == cat.list.length - 1
                            ? ''
                            : 'border-bottom-3d'
                          : i == tab.data.length - 1 && j == cat.list.length - 1
                          ? 'border-top-3d'
                          : 'border-3d'
                      "
                    >
                      <app-tab-tag-component
                        [tab_id]="tab_id"
                      ></app-tab-tag-component>
                    </div>
                    <div
                      *ngIf="item?.chatWithAdminIcon"
                      [ngClass]="
                        i == 0 && j == 0
                          ? i == tab.data.length - 1 && j == cat.list.length - 1
                            ? ''
                            : 'border-bottom-3d'
                          : i == tab.data.length - 1 && j == cat.list.length - 1
                          ? 'border-top-3d'
                          : 'border-3d'
                      "
                    >
                      <app-tab-chat-with-admin-icon-component
                        [tab_id]="tab_id"
                      ></app-tab-chat-with-admin-icon-component>
                    </div>
                    <div
                      *ngIf="item?.postTags"
                      [ngClass]="
                        i == 0 && j == 0
                          ? i == tab.data.length - 1 && j == cat.list.length - 1
                            ? ''
                            : 'border-bottom-3d'
                          : i == tab.data.length - 1 && j == cat.list.length - 1
                          ? 'border-top-3d'
                          : 'border-3d'
                      "
                    >
                      <app-tab-post-tags-component
                        [tab_id]="tab_id"
                      ></app-tab-post-tags-component>
                    </div>
                    <div
                      *ngIf="item?.contextMenu"
                      [ngClass]="
                        i == 0 && j == 0
                          ? i == tab.data.length - 1 && j == cat.list.length - 1
                            ? ''
                            : 'border-bottom-3d'
                          : i == tab.data.length - 1 && j == cat.list.length - 1
                          ? 'border-top-3d'
                          : 'border-3d'
                      "
                    >
                      <app-tab-post-context-menu-component
                        [tab_id]="tab_id"
                      ></app-tab-post-context-menu-component>
                    </div>
                    <div
                      *ngIf="item?.bubble_theme"
                      [ngClass]="
                        i == 0 && j == 0
                          ? i == tab.data.length - 1 && j == cat.list.length - 1
                            ? ''
                            : 'border-bottom-3d'
                          : i == tab.data.length - 1 && j == cat.list.length - 1
                          ? 'border-top-3d'
                          : 'border-3d'
                      "
                    >
                      <app-tab-bubble-themes-component
                        [tab_id]="tab_id"
                      ></app-tab-bubble-themes-component>
                    </div>
                    <div
                      *ngIf="item?.enable_invitation_links"
                      [ngClass]="
                        i == 0 && j == 0
                          ? i == tab.data.length - 1 && j == cat.list.length - 1
                            ? ''
                            : 'border-bottom-3d'
                          : i == tab.data.length - 1 && j == cat.list.length - 1
                          ? 'border-top-3d'
                          : 'border-3d'
                      "
                    >
                      <app-tab-enable-invitation-link-component
                        [tab_id]="tab_id"
                      ></app-tab-enable-invitation-link-component>
                    </div>
                    <div
                      *ngIf="item?.enable_public_group"
                      [ngClass]="
                        i == 0 && j == 0
                          ? i == tab.data.length - 1 && j == cat.list.length - 1
                            ? ''
                            : 'border-bottom-3d'
                          : i == tab.data.length - 1 && j == cat.list.length - 1
                          ? 'border-top-3d'
                          : 'border-3d'
                      "
                    >
                      <app-tab-enable-public-group-component
                        [tab_id]="tab_id"
                      ></app-tab-enable-public-group-component>
                    </div>
                    <div
                      *ngIf="item?.channel_admin_talk"
                      [ngClass]="
                        i == 0 && j == 0
                          ? i == tab.data.length - 1 && j == cat.list.length - 1
                            ? ''
                            : 'border-bottom-3d'
                          : i == tab.data.length - 1 && j == cat.list.length - 1
                          ? 'border-top-3d'
                          : 'border-3d'
                      "
                    >
                      <app-tab-channel-chat-with-admin-component
                        [tab_id]="tab_id"
                      ></app-tab-channel-chat-with-admin-component>
                    </div>
                    <div
                      *ngIf="item?.channel_footer"
                      [ngClass]="
                        i == 0 && j == 0
                          ? i == tab.data.length - 1 && j == cat.list.length - 1
                            ? ''
                            : 'border-bottom-3d'
                          : i == tab.data.length - 1 && j == cat.list.length - 1
                          ? 'border-top-3d'
                          : 'border-3d'
                      "
                    >
                      <app-tab-channel-footer-component
                        [tab_id]="tab_id"
                      ></app-tab-channel-footer-component>
                    </div>
                    <div
                      *ngIf="item?.channel_context_menu"
                      [ngClass]="
                        i == 0 && j == 0
                          ? i == tab.data.length - 1 && j == cat.list.length - 1
                            ? ''
                            : 'border-bottom-3d'
                          : i == tab.data.length - 1 && j == cat.list.length - 1
                          ? 'border-top-3d'
                          : 'border-3d'
                      "
                    >
                      <app-tab-channel-context-menu-component
                        [tab_id]="tab_id"
                      ></app-tab-channel-context-menu-component>
                    </div>
                  </div>
                </ng-container>
              </ul>
            </div>
          </tab>
        </ng-container>
      </tabset>
    <!-- </ngx-simplebar> -->
  </div>
</div>
